import React from "react";
import { initials } from "../admin/store";

const COLORS = ["#1e3a8a", "#0f766e", "#9a3412", "#6d28d9", "#be123c", "#0369a1", "#4d7c0f"];

export default function AuthorAvatar({ author, size = 40, className = "" }) {
    const name = author ? author.name : "MM AutoTech";
    const style = { width: size, height: size, minWidth: size };
    if (author && author.avatar) {
        return (
            <img
                src={author.avatar}
                alt={name}
                style={style}
                className={`rounded-full object-cover ${className}`}
                loading="lazy"
            />
        );
    }
    const color = COLORS[[...name].reduce((s, c) => s + c.charCodeAt(0), 0) % COLORS.length];
    return (
        <span
            style={{ ...style, background: color, fontSize: size * 0.38 }}
            className={`rounded-full inline-flex items-center justify-center text-white font-semibold ${className}`}
            aria-hidden="true"
        >
            {initials(name)}
        </span>
    );
}
